/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 17:07:56
 */ 
export const memberInquirySheetEn = {
    xunjiadang:'Inquiry sheet',
    kaishishijian:'start time',
    jieshushijian:'End time',
    // shushuru:'Please enter service name or order number keyword',
    shushuru:'Please enter order number keyword',
    sousuo:'search',
    quanbuzixundang:'All consultation sheets',
    baojiazhong:'Quotation',
    yibaojia:'Quoted price',
    yixiadang:'Order placed',
    yiquxiao: "Cancelled",
    zhixundangneirong:'Contents of consultation sheet',
    jiage:'price',
    zhuantai:'state',
    caozuo:'operation',
    hanghemingcheng:'Trade name',
    fuwuleimu:'Service category',
    fuwumingcheng:'Service name',
    xunjiadanhao: "Consultation No. :",
    xiadansj: "order time:",
    jianyansf: "Inspection province:",
    jianyancs: "Test city:",
    zhanwu: "no data",
    daibaojia: "To quote",
    querenbaojia: "Confirm the quotation",
    jinruxunjiadan: "details ",
}


// WEBPACK FOOTER //
// ./src/lang/member/memberInquirySheet/memberInquirySheetEn.js